import { Component } from '@angular/core';
import { combineLatest, of, Subject } from 'rxjs';
import { catchError, distinctUntilChanged, map, startWith, switchMap } from 'rxjs/operators';
import { ChallengeGeographyService } from '../services/challenge-geography.service';
import { StreakerCentralStateService } from '../services/streaker-central-state.service';
import { CentralDataService } from '../services/central-data.service';
import { ChallengeGeography } from '../models/geography.models';

@Component({selector:'app-central-geography',templateUrl:'./central-geography.component.html',styleUrls:['./central-geography.component.scss']})
export class CentralGeographyComponent {
    private _refresh = new Subject<void>();
    readonly view$ = combineLatest([
        this._state.state$.pipe(map(s => ({id:s.challenge?.ChallengeDefinitionId || 0,user:s.userId,loading:s.loading})),distinctUntilChanged((a,b) => JSON.stringify(a) === JSON.stringify(b))),
        this._data.changed$.pipe(startWith(null)),this._refresh.pipe(startWith(null))
    ]).pipe(switchMap(([context]) => {
        const empty = {loading:context.loading,error:'',data:null as ChallengeGeography};
        if (!context.id || context.loading) return of(empty);
        return this._geography.load(context.id).pipe(map(data => ({...empty,data,loading:false})),
            catchError(() => of({...empty,loading:false,error:'Unable to load streaker locations.'})),startWith({...empty,loading:true}));
    }));
    constructor(private _state: StreakerCentralStateService,private _geography: ChallengeGeographyService,private _data: CentralDataService) {}
    refresh(): void { this._geography.expire(this._state.state.challenge?.ChallengeDefinitionId || 0); this._refresh.next(); }
}
